import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Hero.css';

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section className="hero" id="hero">
      <div className="hero-overlay">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1 className="hero-title">
                SMART WIRELESS MONITORING
                <span className="highlight"> SOLUTIONS</span>
              </h1>
              <p className="hero-subtitle">
                Advanced wireless monitoring and control systems for both temperature and water level management. 
                Monitor, control, and optimize your systems with real-time data, intelligent automation, and 
                comprehensive insights for complete peace of mind.
              </p>
           
              <div className="hero-buttons">
                <button 
                  className="btn btn-primary"
                  onClick={() => navigate('/client-login')}
                >
                  Get Started
                </button>
                <button 
                  className="btn btn-secondary"
                  onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
                >
                  Contact Us
                </button>
              </div>
            </div>
            <div className="hero-image">
              <div className="hero-visual">
                <div className="feature-showcase">
                  <div className="showcase-item">
                    <div className="showcase-icon">🌡️</div>
                    <h3>Temperature Control</h3>
                    <p>Precise wireless monitoring</p>
                  </div>
                  <div className="showcase-item">
                    <div className="showcase-icon">�</div>
                    <h3>Water Level Control</h3>
                    <p>Smart tank monitoring</p>
                  </div>
                  <div className="showcase-item">
                    <div className="showcase-icon">�📡</div>
                    <h3>Wireless System</h3>
                    <p>Remote management</p>
                  </div>
                  <div className="showcase-item">
                    <div className="showcase-icon">📊</div>
                    <h3>Real-time Data</h3>
                    <p>Live monitoring & alerts</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
